const urlParams = new URLSearchParams(window.location.search);
const testMode = urlParams.get('testMode');

if (!testMode) {
    module.exports = {
        app_env: process.env.REACT_APP_ENVIRONMENT,
        sentry_dsn: process.env.REACT_APP_SENTRY_DSN,
        pgai_bot_url: process.env.REACT_APP_PGAI_BOT_URL,
        signup_api_url: process.env.REACT_APP_SIGNUP_API_URL,
        streaming_url: process.env.REACT_APP_STREAMING_URL,
        summary_data_url: process.env.REACT_APP_SUMMARY_DATA_URL,
        detailed_data_url: process.env.REACT_APP_DETAILED_DATA_URL,
        grader_data_dump_url: process.env.REACT_APP_GRADER_DATA_DUMP_API_URL,
        web_app_url: process.env.REACT_APP_WEB_APP_URL,
        cloudwatch_endpoint_url: process.env.REACT_APP_CLOUDWATCH_ENDPOINT_URL,
        cloudwatch_logger: process.env.REACT_APP_CLOUDWATCH_LOGGER,
        cloudwatch_stream_name_suffix: process.env.REACT_APP_CLOUDWATCH_STREAM_NAME_SUFFIX,
        ga_tracking_code: process.env.REACT_APP_GA_TRACKING_CODE,
        ga4_measurement_id: process.env.REACT_APP_GA4_MEASURMENT_ID,
        geolocation_api_url: process.env.REACT_APP_GEOLOCATION_API_URL,
    }
}
else {
    module.exports = {
        app_env: process.env.REACT_APP_ENVIRONMENT,
        sentry_dsn: process.env.REACT_APP_SENTRY_DSN_TEST,
        pgai_bot_url: process.env.REACT_APP_PGAI_BOT_URL_TEST + '?testMode=true',
        signup_api_url: process.env.REACT_APP_SIGNUP_API_URL_TEST + '&testMode=true',
        streaming_url: process.env.REACT_APP_STREAMING_URL_TEST,
        summary_data_url: process.env.REACT_APP_SUMMARY_DATA_URL_TEST,
        detailed_data_url: process.env.REACT_APP_DETAILED_DATA_URL_TEST + '?testMode=true',
        grader_data_dump_url: process.env.REACT_APP_GRADER_DATA_DUMP_API_URL_TEST + '?testMode=true',
        web_app_url: process.env.REACT_APP_WEB_APP_URL,
        cloudwatch_endpoint_url: process.env.REACT_APP_CLOUDWATCH_ENDPOINT_URL,
        cloudwatch_logger: process.env.REACT_APP_TEST_CLOUDWATCH_LOGGER,
        cloudwatch_stream_name_suffix: process.env.REACT_APP_CLOUDWATCH_STREAM_NAME_SUFFIX,
        ga_tracking_code: process.env.REACT_APP_GA_TEST_TRACKING_CODE,
        ga4_measurement_id: process.env.REACT_APP_GA4_TEST_MEASURMENT_ID,
        geolocation_api_url: process.env.REACT_APP_GEOLOCATION_API_URL,
    }
}